// Shared formatters for the Polymarket dashboard (pure functions, no JSX).

export const usd = (v) =>
  (v == null || isNaN(v) ? "—" : `$${Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export const pct = (v) => (v == null || isNaN(v) ? "—" : `${Number(v) >= 0 ? "+" : ""}${Number(v).toFixed(2)}%`);

export const pnlCls = (v) => (Number(v) > 0 ? "text-emerald-400" : Number(v) < 0 ? "text-rose-400" : "text-muted-foreground");

export const short = (w) => (w && w.length > 12 ? `${w.slice(0, 6)}…${w.slice(-4)}` : w || "—");

export const fmtUsdShort = (v) => {
  const x = Number(v) || 0;
  if (x >= 1e6) return `${(x / 1e6).toFixed(1)}M`;
  if (x >= 1e3) return `${(x / 1e3).toFixed(0)}k`;
  return `${x.toFixed(0)}`;
};

// whale "name" from the Data API is often the wallet itself (0x...-suffix); show a
// readable pseudonym when present, otherwise a shortened wallet.
export const whaleName = (w) => {
  const n = w?.name;
  if (n && !/^0x[0-9a-fA-F]/.test(String(n))) return n;
  return short(w?.wallet);
};

export const timeAgo = (ts) => {
  if (!ts) return "—";
  const s = Math.max(0, Math.floor(Date.now() / 1000 - Number(ts)));
  if (s < 60) return `${s}s fa`;
  if (s < 3600) return `${Math.floor(s / 60)}m fa`;
  if (s < 86400) return `${Math.floor(s / 3600)}h fa`;
  return `${Math.floor(s / 86400)}g fa`;
};

export const sideCls = (side) =>  String(side).toUpperCase() === "BUY"
    ? "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30"
    : "bg-rose-500/15 text-rose-300 border border-rose-500/30";

export const wrCls = (wr) =>
  wr == null ? "text-muted-foreground border-border bg-card/40"
    : wr >= 60 ? "text-emerald-300 border-emerald-500/30 bg-emerald-500/10"
      : wr >= 45 ? "text-amber-300 border-amber-400/30 bg-amber-400/10"
        : "text-rose-300 border-rose-500/30 bg-rose-500/10";

export const scoreCls = (s) =>
  s >= 65 ? "text-emerald-400 border-emerald-400/40 bg-emerald-400/10"
    : s >= 45 ? "text-amber-300 border-amber-400/40 bg-amber-400/10"
      : "text-rose-400 border-rose-400/40 bg-rose-400/10";


// Live +EV profile band adherence (shared by Overview widget + Crescita monitor).
export const bandStats = (settings, positions = []) => {
  const pmin = Number(settings?.signalMinPrice ?? 0.6);
  const pmax = Number(settings?.signalMaxPrice ?? 0.9);
  const n = (positions || []).length;
  const inBand = (positions || []).filter(
    (p) => Number(p.entryPrice) >= pmin && Number(p.entryPrice) <= pmax
  ).length;
  return { pmin, pmax, n, inBand, compliance: n ? Math.round((inBand / n) * 100) : null };
};
